import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'
import Toggle from 'material-ui/Toggle'

import Styles from './index.scss'
import StylesJS from './styles'

const renderTitle = props => (
  <div>
    {props.title}
  </div>
)

const inputNotEmpty = (props) => {
  if (
    props.data.service !== '' &&
    props.data.name !== ''
  ) {
    return true
  }
  return false
}

const renderActions = props => (
  <div className={Styles['btn-container']}>
    <button
      className={Styles['btn-cancel']}
      onClick={props.openModalFormat(false)}
    >
      Cancel
    </button>
    <button
      className={`${Styles['btn-confirm']} ${inputNotEmpty(props) ? '' : Styles['btn-disabled']}`}
      onClick={props.onClickConfirm}
      disabled={!inputNotEmpty(props)}
    >
      Confirm
    </button>
  </div>
)

const ModalAddEdit = props => (
  <Dialog
    title={renderTitle(props)}
    titleStyle={StylesJS.titleStyles}
    actions={renderActions(props)}
    actionsContainerStyle={StylesJS.actionsStyles}
    bodyStyle={StylesJS.contentStyles}
    open={props.isModalOpen}
    onRequestClose={props.openModalFormat(false)}
  >
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Category type<sup>*</sup></div>
      <div className={Styles['field-input']}>
        <select
          onChange={props.setInputDataAdd('service')}
          value={props.data.service}
          disabled={props.isEditFormat}
        >
          <option value="">--- Service List ---</option>
          {props.serviceSelections.map(serviceSelection => (
            <optgroup label={serviceSelection.name} key={serviceSelection.id}>
              {serviceSelection.service.map(service => (
                <option key={service.id} value={service.id}>{service.name}</option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>
    </div>
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Sub-category name <sup>*</sup></div>
      <div className={Styles['field-input']}>
        <input
          className={Styles['input-tag']}
          onChange={props.setInputDataAdd('name')}
          value={props.data.name}
        />
      </div>
    </div>
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Show on service editor</div>
      <div className={Styles['field-input']}>
        <Toggle
          defaultToggled={props.data.isUsable}
          onToggle={props.setInputDataAdd('isUsable')}
        />
      </div>
    </div>
    <div className={Styles['field-container']}>
      <div className={Styles['field-title']}>Show on search/browse</div>
      <div className={Styles['field-input']}>
        <Toggle
          defaultToggled={props.data.isSearchable}
          onToggle={props.setInputDataAdd('isSearchable')}
          disabled // temporary disabled for further development
        />
      </div>
    </div>
  </Dialog>
)

ModalAddEdit.defaultProps = {
  isModalOpen: false,
  openModalFormat: () => { },
  productTypes: {
    rows: [],
  },
  setInputDataAdd: () => { },
  data: {
    productType: '',
    name: '',
    serviceTitle: '',
    serviceDesc: '',
    isUsable: true,
    isSearchable: true,
  },
  serviceSelections: [],
  isEditFormat: false,
}

renderTitle.defaultProps = {
  title: '',
}

renderActions.defaultProps = {
  openModalFormat: () => { },
  onClickConfirm: () => { },
}

ModalAddEdit.propTypes = {
  isModalOpen: PropTypes.bool,
  openModalFormat: PropTypes.func,
  setInputDataAdd: PropTypes.func,
  data: PropTypes.shape({
    service: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    isUsable: PropTypes.bool,
    isSearchable: PropTypes.bool,
  }),
  serviceSelections: PropTypes.arrayOf(PropTypes.shape({})),
  isEditFormat: PropTypes.bool,
}

renderActions.propTypes = {
  openModalFormat: PropTypes.func,
  onClickConfirm: PropTypes.func,
}

renderTitle.propTypes = {
  title: PropTypes.string,
}

export default ModalAddEdit
